import { Component, OnInit } from '@angular/core';
import { InteractionService } from '../../services/interaction.service';

@Component({
  selector: 'swapp-help-widget',
  templateUrl: './help-widget.component.html',
  styleUrls: ['./help-widget.component.scss']
})
export class HelpWidgetComponent implements OnInit {

  constructor(
    public interact: InteractionService
  ) { }

  ngOnInit(): void {
  }

}
